import { render, staticRenderFns } from "./FuncionarioEditarSede.vue?vue&type=template&id=5cfb71f0&"
import script from "./FuncionarioEditarSede.vue?vue&type=script&lang=js&"
export * from "./FuncionarioEditarSede.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports